module.exports = __webpack_public_path__ + "img/student.e8f859e3.svg";